import React from 'react';
import CommonTable from '../../../components/Shared/Tables/TableV1.tsx';
import useUserSx from '../hooks/useUserSx';

export default function UserDataTable({
  muiTableHeadCellProps,
  muiTableHeadRowProps,
  muiTableBodyCellProps,
  muiTableBodyRowProps,
  muiTablePaperProps,
  muiTableContainerProps,
  muiBottomToolbarProps,
  layoutMode = 'semantic',
  enableColumnPinning = false,
  ...props
}) {
  const styles = useUserSx();

  return (
    <CommonTable
      {...props}
      layoutMode={layoutMode}
      enableColumnPinning={enableColumnPinning}
      muiTablePaperProps={{
        elevation: 0,
        ...muiTablePaperProps,
        sx: {
          ...styles.tablePaper,
          ...(muiTablePaperProps?.sx ?? {}),
        },
      }}
      muiTableContainerProps={{
        ...muiTableContainerProps,
        sx: {
          ...styles.tableContainer,
          ...(muiTableContainerProps?.sx ?? {}),
        },
      }}
      muiTableHeadRowProps={{
        ...muiTableHeadRowProps,
        sx: {
          ...styles.tableHeadRow,
          ...(muiTableHeadRowProps?.sx ?? {}),
        },
      }}
      muiTableHeadCellProps={{
        ...muiTableHeadCellProps,
        sx: {
          ...styles.tableHeadCell,
          ...(muiTableHeadCellProps?.sx ?? {}),
        },
      }}
      muiTableBodyCellProps={{
        ...muiTableBodyCellProps,
        sx: {
          ...styles.tableBodyCell,
          whiteSpace: 'nowrap',
          ...(muiTableBodyCellProps?.sx ?? {}),
        },
      }}
      muiTableBodyRowProps={{
        ...muiTableBodyRowProps,
        sx: {
          ...styles.tableBodyRow,
          ...(muiTableBodyRowProps?.sx ?? {}),
        },
      }}
      muiBottomToolbarProps={{
        ...muiBottomToolbarProps,
        sx: {
          bgcolor: 'transparent',
          boxShadow: 'none',
          ...(muiBottomToolbarProps?.sx ?? {}),
        },
      }}
    />
  );
}
